import { Injectable } from '@angular/core';
import { ConfirmationModalService } from '@core/customCDK/cdkCustomMdl/services/confirmation-modal.service';
import { CustomOtpViewComponent } from '@core/custome-modal/custom-otp/custom-otp-view/custom-otp-view.component';
import { pytCustTblDefConfig } from '@core/custome-modal/pytCustTbl/pytCustTbl.helper';
import { config } from '@core/interfaces/api_baseurl';
import { AuthService } from '@core/services/auth.service';
import { BehaviorSubject, tap } from 'rxjs';
import { ApiAccessControlService } from '../../helper/api-access-control.service';
import { ToasterService } from '@core/services/toaster.service';
import { CredtionalModalComponent } from '@page/verify-otp/credtional-modal/credtional-modal.component';
import { MdlExitOptions } from '@page/bill-pay-services/bill-pay-services.component';
import { PytCustTblService } from '@core/custome-modal/pytCustTbl/pyt-cust-tbl.service';
import { DashboardService } from '@page/dashboard/helper/dashboard.service';
import { ConnectBank } from '@core/services/connect-bank.service';
import { ConnectBankService } from '@page/connect-bank-account/helper/connect-bank-account.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CredentialsService {
  Api_Key_List = new BehaviorSubject<any>(null)
  constructor(
    private _AuthService: AuthService,
    private _ConfirmationModalService: ConfirmationModalService,
    private _ApiAccessControlService: ApiAccessControlService,
    private _ToasterService: ToasterService,
    private _PytCustTblService: PytCustTblService,
    private _ConnectBankService: ConnectBankService,
    private _Router: Router,
  ) { }

  fetchCredentialsList(fetch: boolean = false) {
    if (this.Api_Key_List.getValue() && !fetch) {
      return this.Api_Key_List.asObservable();
    }
    return this._AuthService.postdata(this.setFormData(), config.Api_Key.getList).pipe(tap((res: any) => {
      this.Api_Key_List.next(res);
    }));
  }

  setFormData() {
    const formdata = new FormData();
    const { serverSearchVal,
      itmeLengthStartFrom,
      totalItmePerPage,
      sortBy,
      sortDirection } = pytCustTblDefConfig;
    formdata.append('search', serverSearchVal);
    formdata.append('start', itmeLengthStartFrom.toString());
    formdata.append('length', totalItmePerPage.toString());
    formdata.append('orderby', sortBy);
    formdata.append('order', sortDirection);
    return formdata;
  }

  GenerateAPIKey(data?: any) {
    this._ApiAccessControlService.sendOtp().subscribe((res: any) => {
      if (res.code === 200) {
        this._ApiAccessControlService.OtpModal(data)
          .subscribe((events: any) => {

            switch (events.type) {
              case 'sendOtp':
                this._ApiAccessControlService.apiAccessVerifyOtp(events.data).subscribe((res: any) => {
                  if (res.code === 200) {
                    events.initRef.close();

                    this.createApiKey().subscribe((res: any) => {
                      if (res.code === 200) {
                        this.fetchCredentialsList(true).subscribe();
                        let secretKey = res.data;
                        let mapped = Object.keys(secretKey).map((key) => ({
                          type: key,
                          value: secretKey[key],
                        }));
                        this._ConfirmationModalService.init(CredtionalModalComponent, {
                          data: secretKey,
                          
                        }).subscribe((events: any) => {
                          
                          switch (events.type) {
                            case MdlExitOptions.BTN_Confirm:
                              this._PytCustTblService.exportFile(
                                'credentials.txt',
                                '.txt',
                                mapped
                              );
                              
                              // _Router.navigateByUrl('/inventory-kit');
                              // this.tableOptions
                              break;
                            case MdlExitOptions.BTN_Close:
                              if (this._Router.url.includes('/dashboard')) {
                                this._ConnectBankService.getAllBankDetailsList().subscribe((res: any) => {});
                              }                              
                              break
                            case MdlExitOptions.BTN_Cancel:
                              break;
                          }
                          
                          events.initRef.close();
                        });
                      }

                    });
                    this._ToasterService.showSuccess(res.message, 'success');
                  } else {
                    this._ToasterService.showError(res.message, 'error');
                  }
                });
                break;
              case 'resendOtp':
                this._ApiAccessControlService.sendOtp().subscribe();
                break;
              case 'closeTemplateModal':
                events.initRef.close();
                break;
            }
          })
      }
    });
  }



  createApiKey() {
    const formData = new FormData();
    formData.append('expire_at', "never");
    return this._AuthService.postdata(formData, config.Api_Key.createApiKey);
  }

  sendCredEmailVerifyOtp(formData: FormData) {
    return this._AuthService.postdata(formData, config.Api_Key.sendCredEmail);
  }

  deactiveKey(formData: FormData) {
    return this._AuthService.postdata(formData, config.Api_Key.deactiveKey);
  }

}
